import { createContext, useState, useEffect, useContext } from "react"
import { decrypt } from "./CryptoUtil"
import { useGlobalContext, decryptUsername } from "./GlobalContext"

const LeaderboardContext = createContext()

export const LeaderboardProvider = ({ children }) => {
  const { username } = useGlobalContext()
  const [leaderboardData, setLeaderboardData] = useState([])
  const [loadingBoard, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [playerPosition, setPlayerPosition] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const DEBUG = false

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  const getBonusByRank = (rank) => {
    const r = parseInt(rank, 10)
    if (r === 1) return 5000
    if (r === 2) return 3500
    if (r === 3) return 2500
    if (r >= 4 && r <= 5) return 2000
    if (r >= 6 && r <= 10) return 1500
    if (r >= 11 && r <= 20) return 1000
    return 0
  }

  const getPlayerPosition = () => {
    const storedUsername = decryptUsername(localStorage.getItem("username"))
    if (!storedUsername) return null

    if (DEBUG) {
      console.log("[DEBUG] Matching storedUsername:", storedUsername)
      console.log(
        "[DEBUG] Against leaderboard randomChars:",
        leaderboardData.map((e) => e.randomChars)
      )
    }

    const found = leaderboardData.find(
      (entry) => entry.randomChars === storedUsername
    )

    return found ? parseInt(found.ranking, 10) : null
  }

  // useEffect(() => {
  //   if (!isLoggedIn) return
  //   const fetchLeaderboardData = async () => {
  //     try {
  //       setLoading(true)
  //       const url = `${process.env.REACT_APP_API_JSON_URL_PROMO}?cmd=getBNGLeaderboard2`
  //       if (DEBUG) console.log("[DEBUG] Fetching leaderboard from:", url)

  //       const response = await fetch(url)
  //       if (!response.ok) throw new Error(`HTTP error: ${response.status}`)

  //       const rawData = await response.json()
  //       if (DEBUG) console.log("[DEBUG] Raw leaderboard data:", rawData)

  //       const parsedData = await Promise.all(
  //         Object.entries(rawData).map(async ([ranking, value]) => {
  //           const parts = value.split(",")
  //           const username = parts[0]?.trim()
  //           const freebets = parts[1]?.split("|")[1]?.trim() || "0"

  //           const encryptedRandom = parts[2]?.trim() || ""
  //           let randomChars = ""
  //           try {
  //             const decrypted = await decrypt(encryptedRandom)
  //             randomChars =
  //               typeof decrypted === "object"
  //                 ? JSON.stringify(decrypted)
  //                 : decrypted || ""
  //           } catch (e) {
  //             console.error("Decrypt error:", e)
  //             randomChars = encryptedRandom
  //           }

  //           if (DEBUG) {
  //             console.log(`[DEBUG] Rank ${ranking}:`, {
  //               username,
  //               freebets,
  //               randomChars,
  //             })
  //           }

  //           return { ranking, username, freebets, randomChars }
  //         })
  //       )

  //       if (DEBUG) console.log("[DEBUG] Parsed leaderboard data:", parsedData)
  //       setLeaderboardData(parsedData.slice(0, 20))
  //     } catch (err) {
  //       console.error("Leaderboard API error:", err)
  //       setError(err)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  //   fetchLeaderboardData()
  // }, [isLoggedIn])

  useEffect(() => {
    const pos = getPlayerPosition()
    if (pos !== null) setPlayerPosition(pos)
  }, [leaderboardData])

  return (
    <LeaderboardContext.Provider
      value={{
        leaderboardData,
        loadingBoard,
        error,
        getBonusByRank,
        getPlayerPosition,
        playerPosition,
      }}
    >
      {children}
    </LeaderboardContext.Provider>
  )
}

export const useLeaderboard = () => useContext(LeaderboardContext)
